/**
 * Hebrew Labels Configuration
 *
 * Centralized Hebrew labels for object names and field names.
 * Extracted from App.js objectConfig and fieldLabels.
 */

// Object API name -> Hebrew label
export const HEBREW_OBJECT_LABELS = {
  'Account': 'חשבונות',
  'Contact': 'אנשי קשר',
  'Opportunity': 'הזדמנויות',
  'OpportunityLineItem': 'פריטי הזדמנות',
  'Lead': 'לידים',
  'Case': 'מקרים',
  'Task': 'משימות',
  'Event': 'אירועים',
  'Campaign': 'מבצעי קידום',
  'User': 'משתמשים',
  'Product2': 'מוצרים',
  'Pricebook2': 'מחירונים',
  'Order': 'הזמנות',
  'Contract': 'חוזים',
  'Quote': 'הצעות מחיר',
  'Asset': 'נכסים',
  'WorkOrder': 'הזמנות עבודה',
  'ServiceAppointment': 'פעילות שירות',
  'WorkOrderLineItem': 'פריטי הזמנת עבודה',
  'ServiceResource': 'משאבי שירות',
  'ServiceTerritory': 'אזורי שירות',
  'ServiceTerritoryMember': 'חברי אזור שירות',
  'AssignedResource': 'משאבים שהוקצו',
  'ServiceContract': 'חוזי שירות',
  'Attachment': 'קבצים מצורפים',
  'ContentDocumentLink': 'קבצים',
  'ResourceAbsence': 'היעדרויות משאבים',
  'OperatingHours': 'שעות פעילות',
  'TimeSlot': 'משבצות זמן',
  'WorkType': 'סוגי עבודה',
  'EntityHistory': 'היסטוריית פעילות',
  'ProductRequired': 'מוצרים נדרשים',
  'ProductRequest': 'בקשות מוצרים',
  'ServiceAppointmentHistory': 'היסטוריית פעילות שירות',
  'TechnicianWallet__c': 'ארנק טכנאי',
  'Manufacturer__c': 'יצרנים',
  'Activity_Barak__c': 'פעילות ברק',
  'Address_Change_Log__c': 'יומן שינוי כתובת',
  'Auto_Order__c': 'הזמנה אוטומטית',
  'Bin_Location__c': 'מיקום מחסן',
  'Bypass_Settings__c': 'הגדרות עקיפה',
  'Location': 'מיקומים',
  'ProductItem': 'פריטי מוצר',
  'ProductItemTransaction': 'תנועות פריטי מוצר',
  'ProductConsumed': 'מוצרים שנצרכו',
  'ProductTransfer': 'העברות מוצרים',
  'SerializedProduct': 'מוצרים עם מספר סידורי',
  'PricebookEntry': 'פריטי מחירון',
  'Entitlement': 'זכאויות',
  'ReturnOrder': 'הזמנות החזרה',
  'ContentVersion': 'גרסאות תוכן',
  'ContentFolder': 'תיקיות תוכן',
  'CampaignMember': 'חברי קמפיין',
  'OpportunityContactRole': 'תפקידי אנשי קשר בהזדמנות',
  'OpportunityHistory': 'היסטוריית הזדמנויות',
  'UserRole': 'תפקידי משתמשים',
  'OperatingHoursHoliday': 'חגים בשעות פעילות',
  'WorkCapacityLimit': 'מגבלות קיבולת עבודה',
  // FSL Objects
  'FSL__Criteria__c': 'קריטריונים',
  'FSL__FSL_Operation__c': 'פעולות FSL',
  'FSL__Gantt_Filter__c': 'מסנני גאנט',
  'FSL__Gantt_Palette__c': 'פלטת גאנט',
  'FSL__Optimization_Request__c': 'בקשות אופטימיזציה',
  'FSL__Polygon__c': 'פוליגונים',
  'FSL__Scheduling_Policy__c': 'מדיניות תזמון',
  'FSL__Scheduling_Policy_Goal__c': 'יעדי מדיניות תזמון',
  'FSL__Scheduling_Policy_Work_Rule__c': 'כללי עבודה במדיניות',
  'FSL__Scheduling_Recipe__c': 'מתכוני תזמון',
  'FSL__Service_Goal__c': 'יעדי שירות',
  'FSL__Territory_Optimization_Request__c': 'בקשות אופטימיזציית אזור',
  'FSL__User_Setting__c': 'הגדרות משתמש FSL',
  'FSL__User_Setting_Territory__c': 'הגדרות אזור משתמש',
  'FSL__User_Territory__c': 'אזור משתמש',
  'FSL__Work_Rule__c': 'כללי עבודה',
  // Custom Objects
  'Goods_Receipt__c': 'קבלת סחורה',
  'Goods_Receipt_Line__c': 'שורות קבלת סחורה',
  'MGR__c': 'MGR',
  'Mobile_Payment_Request__c': 'בקשות תשלום מובייל',
  'Payment__c': 'תשלומים',
  'Product_Movement__c': 'תנועות מוצרים',
  'Purchase_Order__c': 'הזמנות רכש',
  'Purchase_Order_Line__c': 'שורות הזמנת רכש',
  'Sales_targets__c': 'יעדי מכירות',
  'Scheduler_Operation_History__c': 'היסטוריית פעולות מתזמן',
  'Scheduling_Approval__c': 'אישורי תזמון',
  'Service_Visit_Feedback__c': 'משוב ביקור שירות',
  'Stock_Transfer__c': 'העברות מלאי',
  'Stock_Transfer_Item__c': 'פריטי העברת מלאי',
  'Technician_Capacity__c': 'קיבולת טכנאי',
  'Technician_Pay_Scale__c': 'סולם שכר טכנאים',
  'Technician_Transfer__c': 'העברות טכנאים',
  'Warehouse_Zone__c': 'אזורי מחסן',
  'Webhook_Data__c': 'נתוני Webhook',
  'Deviation__c': 'סטיות',
  'Manufacturer_Product__c': 'מוצרי יצרן',
  'Dashboard_Rep_Preference__c': 'העדפות דוח לוח מחוונים',
  // Messaging & Communication
  'MessagingSession': 'שיחות הודעות',
  'ListEmail': 'רשימת דוא"ל',
  'EmailRoutingAddress': 'כתובות ניתוב דוא"ל',
  // Other standard objects
  'Period': 'תקופות',
  'ForecastingQuota': 'מכסות תחזית',
  'FlowRecord': 'רשומות Flow',
  'FlowOrchestration': 'תזמורת Flow',
};

// Field API name -> Hebrew label
export const HEBREW_FIELD_LABELS = {
  // Common fields
  'Id': 'מזהה',
  'Name': 'שם',
  'CreatedDate': 'תאריך יצירה',
  'CreatedById': 'נוצר על ידי',
  'LastModifiedDate': 'תאריך עדכון אחרון',
  'LastModifiedById': 'עודכן על ידי',
  'OwnerId': 'בעלים',
  'Owner.Name': 'שם הבעלים',
  'IsDeleted': 'נמחק',
  'SystemModstamp': 'חותמת מערכת',
  'RecordTypeId': 'סוג רשומה',

  // Account fields
  'AccountId': 'חשבון',
  'Account.Name': 'שם החשבון',
  'AccountNumber': 'מספר חשבון',
  'AccountSource': 'מקור חשבון',
  'AnnualRevenue': 'הכנסה שנתית',
  'BillingAddress': 'כתובת לחיוב',
  'BillingCity': 'עיר לחיוב',
  'BillingCountry': 'מדינה לחיוב',
  'BillingPostalCode': 'מיקוד לחיוב',
  'BillingState': 'מחוז לחיוב',
  'BillingStreet': 'רחוב לחיוב',
  'Description': 'תיאור',
  'Fax': 'פקס',
  'Industry': 'ענף',
  'NumberOfEmployees': 'מספר עובדים',
  'ParentId': 'חשבון אב',
  'Parent.Name': 'שם חשבון אב',
  'Phone': 'טלפון',
  'Rating': 'דירוג',
  'ShippingAddress': 'כתובת למשלוח',
  'ShippingCity': 'עיר למשלוח',
  'ShippingCountry': 'מדינה למשלוח',
  'ShippingPostalCode': 'מיקוד למשלוח',
  'ShippingState': 'מחוז למשלוח',
  'ShippingStreet': 'רחוב למשלוח',
  'Site': 'אתר',
  'Type': 'סוג',
  'Website': 'אתר אינטרנט',

  // Contact fields
  'ContactId': 'איש קשר',
  'Contact.Name': 'שם איש הקשר',
  'FirstName': 'שם פרטי',
  'LastName': 'שם משפחה',
  'Email': 'דוא"ל',
  'MobilePhone': 'טלפון נייד',
  'Title': 'תפקיד',
  'Department': 'מחלקה',
  'Birthdate': 'תאריך לידה',
  'MailingAddress': 'כתובת למשלוח דואר',
  'MailingCity': 'עיר',
  'MailingCountry': 'מדינה',
  'MailingPostalCode': 'מיקוד',
  'MailingState': 'מחוז',
  'MailingStreet': 'רחוב',
  'OtherPhone': 'טלפון אחר',
  'ReportsToId': 'מדווח ל',
  'ReportsTo.Name': 'שם הממונה',
  'Salutation': 'תואר פנייה',

  // Opportunity fields
  'OpportunityId': 'הזדמנות',
  'Opportunity.Name': 'שם ההזדמנות',
  'Amount': 'סכום',
  'CloseDate': 'תאריך סגירה',
  'StageName': 'שלב',
  'Probability': 'הסתברות',
  'ExpectedRevenue': 'הכנסה צפויה',
  'ForecastCategory': 'קטגוריית תחזית',
  'ForecastCategoryName': 'שם קטגוריית תחזית',
  'IsClosed': 'סגור',
  'IsWon': 'נסגר בהצלחה',
  'LeadSource': 'מקור ליד',
  'NextStep': 'צעד הבא',
  'CampaignId': 'קמפיין',
  'Campaign.Name': 'שם הקמפיין',
  'Pricebook2Id': 'מחירון',
  'TotalOpportunityQuantity': 'כמות כוללת',

  // Task fields
  'Subject': 'נושא',
  'Status': 'סטטוס',
  'Priority': 'עדיפות',
  'ActivityDate': 'תאריך פעילות',
  'DueDate': 'תאריך יעד',
  'WhoId': 'קשור ל (איש קשר/ליד)',
  'Who.Name': 'שם הקשור',
  'WhatId': 'קשור ל (רשומה)',
  'What.Name': 'שם הרשומה הקשורה',
  'IsHighPriority': 'עדיפות גבוהה',
  'IsRecurrence': 'חוזר',
  'CallType': 'סוג שיחה',
  'CallDurationInSeconds': 'משך שיחה (שניות)',
  'CallObject': 'אובייקט שיחה',
  'ReminderDateTime': 'תאריך תזכורת',
  'IsReminderSet': 'תזכורת מוגדרת',
  'CompletedDateTime': 'תאריך השלמה',

  // Case fields
  'CaseId': 'פנייה',
  'Case.Name': 'מספר פנייה',
  'CaseNumber': 'מספר פנייה',
  'Origin': 'מקור',
  'Reason': 'סיבה',
  'ClosedDate': 'תאריך סגירה',
  'IsEscalated': 'הועלה לדרג',
  'SuppliedName': 'שם שסופק',
  'SuppliedEmail': 'דוא"ל שסופק',
  'SuppliedPhone': 'טלפון שסופק',
  'SuppliedCompany': 'חברה שסופקה',
  'Comments': 'הערות',

  // Asset fields
  'AssetId': 'נכס',
  'Asset.Name': 'שם הנכס',
  'SerialNumber': 'מספר סידורי',
  'InstallDate': 'תאריך התקנה',
  'PurchaseDate': 'תאריך רכישה',
  'UsageEndDate': 'תאריך סיום שימוש',
  'LifecycleStartDate': 'תאריך התחלת מחזור חיים',
  'LifecycleEndDate': 'תאריך סיום מחזור חיים',
  'Price': 'מחיר',
  'Quantity': 'כמות',
  'Product2Id': 'מוצר',
  'Product2.Name': 'שם המוצר',
  'RootAssetId': 'נכס שורש',
  'ParentAssetId': 'נכס אב',
  'IsCompetitorProduct': 'מוצר מתחרה',
  'IsInternal': 'פנימי',
  'StockKeepingUnit': 'יחידת מלאי',
  'HasLifecycleManagement': 'ניהול מחזור חיים',

  // User fields
  'UserId': 'משתמש',
  'User.Name': 'שם המשתמש',
  'Username': 'שם משתמש',
  'Alias': 'כינוי',
  'CommunityNickname': 'כינוי בקהילה',
  'IsActive': 'פעיל',
  'ProfileId': 'פרופיל',
  'Profile.Name': 'שם הפרופיל',
  'UserRoleId': 'תפקיד',
  'UserRole.Name': 'שם התפקיד',
  'ManagerId': 'מנהל',
  'Manager.Name': 'שם המנהל',
  'TimeZoneSidKey': 'אזור זמן',
  'LocaleSidKey': 'אזור',
  'LanguageLocaleKey': 'שפה',
  'EmailEncodingKey': 'קידוד דוא"ל',
  'LastLoginDate': 'כניסה אחרונה',
  'FullPhotoUrl': 'תמונה',
  'SmallPhotoUrl': 'תמונה קטנה',

  // WorkOrder fields
  'WorkOrderId': 'הזמנת עבודה',
  'WorkOrder.Name': 'שם הזמנת העבודה',
  'WorkOrderNumber': 'מספר הזמנת עבודה',
  'WorkTypeId': 'סוג עבודה',
  'WorkType.Name': 'שם סוג העבודה',
  'ServiceTerritoryId': 'אזור שירות',
  'ServiceTerritory.Name': 'שם אזור השירות',
  'StartDate': 'תאריך התחלה',
  'EndDate': 'תאריך סיום',
  'Duration': 'משך זמן',
  'DurationType': 'סוג משך זמן',
  'DurationInMinutes': 'משך בדקות',
  'Street': 'רחוב',
  'City': 'עיר',
  'State': 'מחוז',
  'PostalCode': 'מיקוד',
  'Country': 'מדינה',
  'Latitude': 'קו רוחב',
  'Longitude': 'קו אורך',
  'Address': 'כתובת',
  'IsGeneratedFromMaintenancePlan': 'נוצר מתוכנית תחזוקה',
  'MaintenancePlanId': 'תוכנית תחזוקה',
  'MaintenanceWorkRuleId': 'כלל עבודת תחזוקה',
  'MinimumCrewSize': 'גודל צוות מינימלי',
  'RecommendedCrewSize': 'גודל צוות מומלץ',
  'RootWorkOrderId': 'הזמנת עבודה ראשית',
  'ParentWorkOrderId': 'הזמנת עבודה אב',
  'ParentWorkOrderLineItemId': 'פריט הזמנת עבודה אב',
  'LocationId': 'מיקום',
  'SuggestedMaintenanceDate': 'תאריך תחזוקה מוצע',
  'Tax': 'מס',
  'Subtotal': 'סכום ביניים',
  'TotalPrice': 'מחיר כולל',
  'GrandTotal': 'סכום סופי',
  'Discount': 'הנחה',
  'LineItemCount': 'מספר פריטים',

  // ServiceAppointment fields
  'ServiceAppointmentId': 'פגישת שירות',
  'ServiceAppointment.Name': 'שם פגישת השירות',
  'AppointmentNumber': 'מספר פגישה',
  'ParentRecordId': 'רשומה קשורה',
  'ParentRecord.Name': 'שם הרשומה הקשורה',
  'EarliestStartTime': 'זמן התחלה מוקדם ביותר',
  'ArrivalWindowStartTime': 'התחלת חלון הגעה',
  'ArrivalWindowEndTime': 'סוף חלון הגעה',
  'SchedStartTime': 'זמן התחלה מתוזמן',
  'SCHEDSTARTTIME': 'זמן התחלה מתוזמן',
  'SchedEndTime': 'זמן סיום מתוזמן',
  'ActualStartTime': 'זמן התחלה בפועל',
  'ActualEndTime': 'זמן סיום בפועל',
  'ActualDuration': 'משך בפועל',
  'SERVICETERRITORYID': 'אזור שירות',
  'WORKTYPEID': 'סוג עבודה',
  'ADDRESS': 'כתובת',
  'ServiceNote': 'הערת שירות',
  'FSL__Auto_Schedule__c': 'תזמון אוטומטי',
  'FSL__InJeopardy__c': 'בסיכון',
  'FSL__InJeopardyReason__c': 'סיבת סיכון',
  'FSL__IsMultiDay__c': 'רב-יומי',
  'FSL__Pinned__c': 'נעוץ',
  'FSL__Same_Day__c': 'באותו יום',
  'FSL__Same_Resource__c': 'אותו משאב',
  'FSL__Schedule_Mode__c': 'מצב תזמון',
  'FSL__Scheduling_Policy_Used__c': 'מדיניות תזמון',
  'FSL__Time_Dependency__c': 'תלות זמן',
  'FSL__UpdatedByOptimization__c': 'עודכן באופטימיזציה',
  'FSL__GanttLabel__c': 'תווית גנט',
  'AdditionalInformation': 'מידע נוסף',

  // ServiceResource fields
  'ServiceResourceId': 'משאב שירות',
  'ServiceResource.Name': 'שם משאב השירות',
  'RelatedRecordId': 'רשומה קשורה',
  'ResourceType': 'סוג משאב',
  'IsCapacityBased': 'מבוסס קיבולת',
  'IsOptimizationCapable': 'מסוגל אופטימיזציה',

  // AssignedResource fields
  'AssignedResourceNumber': 'מספר משאב שהוקצה',
  'EstimatedTravelTime': 'זמן נסיעה משוער',
  'ActualTravelTime': 'זמן נסיעה בפועל',
  'IsRequiredResource': 'משאב נדרש',

  // ServiceContract fields
  'ServiceContractId': 'חוזה שירות',
  'ServiceContract.Name': 'שם חוזה השירות',
  'ContractNumber': 'מספר חוזה',
  'Term': 'תקופה',
  'ActivationDate': 'תאריך הפעלה',
  'ApprovalStatus': 'סטטוס אישור',

  // OpportunityLineItem fields
  'OpportunityLineItemId': 'פריט הזדמנות',
  'UnitPrice': 'מחיר ליחידה',
  'ListPrice': 'מחיר מחירון',
  'ProductCode': 'קוד מוצר',
  'ServiceDate': 'תאריך שירות',

  // General lookup fields
  'RecordType.Name': 'שם סוג הרשומה',
  'LastViewedDate': 'נצפה לאחרונה',
  'LastReferencedDate': 'הופנה לאחרונה',

  // Additional ServiceAppointment fields (uppercase API names)
  'ServiceResource': 'משאב שירות',
  'SERVICE RESOURCE': 'משאב שירות',
  'SERVICERESOURCE': 'משאב שירות',
  'ResourceDescription': 'תיאור משאב',
  'RESOURCE DESCRIPTION': 'תיאור משאב',
  'RESOURCEDESCRIPTION': 'תיאור משאב',
  'Product': 'מוצר',
  'PRODUCT': 'מוצר',
  'Product__c': 'מוצר',
  'TimeRangeC': 'טווח זמן',
  'TIME RANGE C': 'טווח זמן',
  'Time_Range__c': 'טווח זמן',
  'ActualBalanceToBePaid': 'יתרה בפועל לתשלום',
  'ACTUAL BALANCE TO BE PAID': 'יתרה בפועל לתשלום',
  'AnotherPhone': 'טלפון נוסף',
  'ANOTHER PHONE': 'טלפון נוסף',
  'ParentCase': 'פנייה אב',
  'PARENT CASE': 'פנייה אב',
  'ParentCaseId': 'פנייה אב',
  'Parent_Case__c': 'פנייה אב',

  // ServiceAppointment custom fields
  'product__c': 'מוצר',
  'product2__c': 'מוצר 2',
  'Service_Resource__c': 'משאב שירות',
  'Resource_Description__c': 'תיאור משאב',
  'Time_Range_c__c': 'טווח זמן',
  'Account_Name__c': 'שם חשבון',
  'AcNumber__c': 'מספר לקוח',
  'Actual_Balance_To_Be_Paid__c': 'יתרה לתשלום בפועל',
  'Another_Phone__c': 'טלפון נוסף',
  'ap_number__c': 'מספר דירה',
  'Apartment_number__c': 'מספר דירה',
  'Apartment_number_AC__c': 'מספר דירה AC',
  'Address_Verified_On_Map__c': 'כתובת אומתה במפה',
  'Entrance__c': 'כניסה',
  'Floor__c': 'קומה',
  'Closing_Employee__c': 'עובד סגירה',
  'CallerPhone__c': 'טלפון מתקשר',
  'Serial_Number__c': 'מספר סידורי',
  'Service_Contract__c': 'חוזה שירות',
  'Service_Contract_Type__c': 'סוג חוזה שירות',
  'Work_Order__c': 'הזמנת עבודה',
  'Work_Type_Text__c': 'סוג עבודה',
  'Client_Comment__c': 'הערת לקוח',
  'Reason_Cannot_Completed__c': 'סיבה שלא הושלם',
  'Deviation_Description__c': 'תיאור חריגה',
  'Deviation_Type__c': 'סוג חריגה',
  'Deviation_Report__c': 'דוח חריגות',
  'How_Client_Pay__c': 'אופן תשלום',
  'How_Much_Client_Pay__c': 'סכום תשלום',
  'NPayments__c': 'מספר תשלומים',
  'Payment_aut__c': 'אישור תשלום',
  'PaymentMadeBySR__c': 'תשלום בוצע ע"י משאב',
  'Receipt_Link__c': 'קישור לקבלה',
  'tech_sale__c': 'מכירה טכנאי',
  'tech_sale_amount__c': 'סכום מכירה טכנאי',
  'Collect_Old_Device__c': 'לאסוף מכשיר ישן מהלקוח',
  'tech_sale_pay_type__c': 'סוג תשלום מכירה',
  'up_sale__c': 'אפ-סייל',
  'up_sale_amount__c': 'סכום אפ-סייל',
  'up_sale_description__c': 'תיאור אפ-סייל',
  'up_sale_np__c': 'תשלומים אפ-סייל',
  'up_sale_payment_type__c': 'סוג תשלום אפ-סייל',
  'Confirmed_By__c': 'אושר על ידי',
  'Number_SA__c': 'מספר פגישה',
  'Installed_Model__c': 'דגם מותקן',
  'mineralisator__c': 'מינרליזטור',
  'Reseller__c': 'משווק',
  'Bank__c': 'בנק',
  'BRANCHE__c': 'סניף',
  'check_id_owner__c': 'ת.ז. בעל צ׳ק',
  'checkOwner__c': 'בעל הצ׳ק',
  'card_type__c': 'סוג כרטיס',
  'cc_digit__c': '4 ספרות אחרונות',
  'Fictitious_Balance__c': 'יתרה פיקטיבית',

  // ProductRequired fields
  'Product_Name__c': 'שם מוצר',
  'ProductRequiredNumber': 'מספר מוצר נדרש',
  'QuantityRequired': 'כמות נדרשת',
  'QuantityUnitOfMeasure': 'יחידת מידה',
  'Reason__c': 'סיבה',
  'Location__c': 'מיקום',

  // More common fields
  'RecordType': 'סוג רשומה',
  'IsPrimary': 'ראשי',
  'IsDefault': 'ברירת מחדל',
  'Notes': 'הערות',
  'Remark': 'הערה',
  'Remarks': 'הערות',

  // Person Account fields
  'PersonLeadSource': 'מקור ליד',
  'PERSON LEAD SOURCE': 'מקור ליד',
  'PersonLeadSource__c': 'מקור ליד',
  'Person_Lead_Source__c': 'מקור ליד',
  'PersonEmail': 'אימייל',
  'PERSON EMAIL': 'אימייל',
  'PersonMobilePhone': 'טלפון נייד',
  'PersonPhone': 'טלפון',
  'PersonTitle': 'תפקיד',
  'PersonBirthdate': 'תאריך לידה',
  'PersonMailingAddress': 'כתובת דואר',
  'PersonOtherAddress': 'כתובת אחרת',

  // Account specific fields
  'AnotherPhone__c': 'טלפון נוסף',
  'CustomerInDebt__c': 'לקוח בחוב',
  'CUSTOMER IN DEBT': 'לקוח בחוב',
  'Customer_In_Debt__c': 'לקוח בחוב',
  // Account fields - all label formats (API name, label, uppercase)
  'ClientId__c': 'תעודת זהות',
  'Client_Id__c': 'תעודת זהות',
  'Client Id': 'תעודת זהות',
  'Client id': 'תעודת זהות',
  'client id': 'תעודת זהות',
  'ApartmentNumber__c': 'מספר דירה',
  'APARTMENT NUMBER': 'מספר דירה',
  'Apartment_Number__c': 'מספר דירה',
  'Apartment Number': 'מספר דירה',
  'Apartment number': 'מספר דירה',
  'apartment number': 'מספר דירה',
  'FLOOR': 'קומה',
  'Floor': 'קומה',
  'floor': 'קומה',
  'ENTRANCE': 'כניסה',
  'Entrance': 'כניסה',
  'entrance': 'כניסה',
  'EntryCode__c': 'קוד כניסה',
  'Entry_Code__c': 'קוד כניסה',
  'Entry Code': 'קוד כניסה',
  'entry code': 'קוד כניסה',
  'StayInTouchRequestDate__c': 'תאריך שמירת קשר',
  'STAY-IN-TOUCH REQUEST DATE': 'תאריך שמירת קשר',
  'Stay_In_Touch_Request_Date__c': 'תאריך שמירת קשר',
  'Stay_In_Touch_request_date__c': 'תאריך שמירת קשר',
  'Stay In Touch Request Date': 'תאריך שמירת קשר',
  'Stay-In-Touch Request Date': 'תאריך שמירת קשר',
  'Stay in touch request date': 'תאריך שמירת קשר',
  'CreateMessagingUser__c': 'יצירת משתמש הודעות',
  'CREATE MESSAGING USER': 'יצירת משתמש הודעות',
  'Create_Messaging_User__c': 'יצירת משתמש הודעות',
  'Create_Messaging_user__c': 'יצירת משתמש הודעות',
  'Create Messaging User': 'יצירת משתמש הודעות',
  'Create Messaging user': 'יצירת משתמש הודעות',
  'InsuredClient__c': 'לקוח מבוטח',
  'INSURED CLIENT': 'לקוח מבוטח',
  'Insured_Client__c': 'לקוח מבוטח',
  'Insured Client': 'לקוח מבוטח',
  'Insured client': 'לקוח מבוטח',
  'insured client': 'לקוח מבוטח',

  // Additional legacy CRM XML labels (exact format)
  'Stay-In-Touch request date': 'תאריך שמירת קשר',
  'Customer in Debt': 'לקוח חייב',
  'Filter replacement date': 'תאריך החלפת פילטר',
  'Passed Warranty?': 'עבר אחריות?',
  'Account management number': 'מספר הנהלת חשבונות',
  'Account management status': 'סטטוס הנהלת חשבונות',
  'Barak Created Date': 'תאריך יצירה ברק',
  'Barak customer status': 'סטטוס לקוח ברק',
  'Barak Description': 'תיאור ברק',
  'Barak Last Modified': 'עדכון אחרון ברק',
  'Barak Migration': 'מיגרציה מברק',
  'Barak Owner': 'בעלים ברק',
  'Barak record number': 'מספר רשומה ברק',
  'Account Number Barak': 'מספר חשבון ברק',
  'Product Code Barak': 'קוד מוצר ברק',
  'Billing Contact': 'איש קשר לחיוב',
  'Change Country': 'שינוי מדינה',
  'Rivhit Customer Id': 'מזהה לקוח ריווחית',
  'AccountId 18': 'מזהה חשבון 18',
  'Warranty End Date': 'תאריך סיום אחריות',
  'Customer In Debt': 'לקוח חייב',
  'customer in debt': 'לקוח חייב',
  'ANOTHER_PHONE__c': 'טלפון נוסף',
  'Another_phone__c': 'טלפון נוסף',
  'Another Phone': 'טלפון נוסף',
  'Another phone': 'טלפון נוסף',
  'another phone': 'טלפון נוסף',
  'ServiceToDifferentAddress__c': 'שירות לכתובת שונה',
  'Service To Different Address': 'שירות לכתובת שונה',
  'Service_To_Different_Address__c': 'שירות לכתובת שונה',
  // More Account field labels from system metadata
  'Parent Account': 'חשבון אב',
  'parent account': 'חשבון אב',

  // Account additional fields
  'Customer_in_Debt__c': 'לקוח חייב',
  'Insured_client__c': 'לקוח מבוטח',
  'PersonHasOptedOutOfEmail': 'ביטל הסכמה למיילים',
  'Filter_replacement_date__c': 'תאריך החלפת פילטר',
  'FILTER REPLACEMENT DATE': 'תאריך החלפת פילטר',
  'Warranty_End_Date__c': 'תאריך סיום אחריות',
  'WARRANTY END DATE': 'תאריך סיום אחריות',
  'Passed_Warranty__c': 'עבר אחריות?',
  'PASSED WARRANTY': 'עבר אחריות?',
  'AccountId_18__c': 'מזהה חשבון 18',
  'ACCOUNTID 18': 'מזהה חשבון 18',
  'Billing_Contact__c': 'איש קשר לחיוב',
  'BILLING CONTACT': 'איש קשר לחיוב',
  'Change_Country__c': 'שינוי מדינה',
  'CHANGE COUNTRY': 'שינוי מדינה',
  'satodifferntadress__c': 'כתובת שירות שונה',
  'InvoiceDetails__c': 'פרטי חשבונית',
  'first_name_fi__c': 'שם פרטי לחשבונית',
  'lastName_FI__c': 'שם משפחה לחשבונית',
  'adresse_fi__c': 'כתובת לחשבונית',
  'city_fi__c': 'עיר לחשבונית',
  'id_fi__c': 'ת.ז./ח.פ. לחשבונית',
  'Account_management_number__c': 'מספר הנהלת חשבונות',
  'Account_management_status__c': 'סטטוס הנהלת חשבונות',
  'Rivhit_Customer_Id__c': 'מזהה לקוח ריווחית',
  'Barak_Description__c': 'תיאור ברק',
  'Account_Number_Barak__c': 'מספר חשבון ברק',
  'Barak_Created_Date__c': 'תאריך יצירה ברק',
  'Barak_customer_status__c': 'סטטוס לקוח ברק',
  'Barak_Migration__c': 'מיגרציה מברק',
  'Barak_Last_Modified__c': 'עדכון אחרון ברק',
  'Barak_record_number__c': 'מספר רשומה ברק',
  'Product_Code_Barak__c': 'קוד מוצר ברק',
  'Barak_Owner__c': 'בעלים ברק',
  'Sync_to_MC__pc': 'סנכרון למרקטינג קלאוד',
  'OptOut__pc': 'ביטל הסכמה',
  'OptOut_Date__pc': 'תאריך ביטול הסכמה',
  'et4ae5__HasOptedOutOfMobile__pc': 'ביטל הסכמה לנייד',
  'Customer_Number__c': 'מספר לקוח',
  'CUSTOMER NUMBER': 'מספר לקוח',
  'CLIENT ID': 'תעודת זהות',
  'entry_code__c': 'קוד כניסה',
  'ENTRY CODE': 'קוד כניסה',
  'BillingAddressForInvoice__c': 'כתובת לחיוב לחשבונית',
  'Billing_Address_For_Invoice__c': 'כתובת לחיוב לחשבונית',
  'DifferentInvoiceDetails__c': 'פרטי חשבונית שונים מחשבון לקוח',
  'Different_Invoice_Details__c': 'פרטי חשבונית שונים',
  'AC_Number__c': 'מספר לקוח',

  // Opportunity custom fields
  'Budget_Confirmed__c': 'תקציב מאושר',
  'Discovery_Completed__c': 'סיור הושלם',
  'ROI_Analysis_Completed__c': 'ניתוח ROI הושלם',
  'Loss_Reason__c': 'סיבת הפסד',
  'Asset__c': 'נכס',
  'Supplier__c': 'ספק',
  'Supplier_New__c': 'ספק חדש',
  'Payments__c': 'תשלומים',
  'Before_Expired_Payment__c': 'לפני תשלום שפג',
  'Send_customer_email__c': 'שלח מייל ללקוח',
  'Service_Appointment__c': 'פעילות שירות',
  'Invoice_Number__c': 'מספר חשבונית',
  'Link_To_Invoice__c': 'קישור לחשבונית',
  'Fictitious_Balance_Due__c': 'יתרה פיקטיבית לתשלום',
  'Pre_Sign_Document_Link_c__c': 'קישור למסמך לפני חתימה',
  'Signed_Document_Link_c__c': 'קישור למסמך חתום',
  'Reseller_order__c': 'מספר הזמנה משווק',
  'Reseller_Order_Date__c': 'תאריך הזמנה משווק',
  'sales_tech__c': 'מכירת טכנאי',
  'Cancellation_Invoice_Number__c': 'מספר חשבונית ביטול',
  'Link_To_Cancellation_Invoice__c': 'קישור לחשבונית ביטול',
  'salesResource__c': 'משאב מכירות',
  // 2026-05-14: refund / זיכוי tracking fields on Opportunity.
  'Refund_Type__c': 'סוג זיכוי',
  'Original_Deal_Amount__c': 'סכום העסקה המקורית',
  'Refund_Amount__c': 'סכום הזיכוי',
  'Refund_Status__c': 'סטטוס הזיכוי',
  'Deal_Counted_For_Bonus_Date__c': 'עסקה נלקחה בחשבון לבונוס בתאריך',
  'Refund_Date__c': 'תאריך זיכוי',
  // 2026-05-14: iCredit bulk-verify fields on Payment__c.
  'Verified_With_iCredit__c': 'נבדק ואומת מול iCredit',
  'Auth_Num__c': 'מספר אישור עסקה',
  'op_number__c': 'מספר הזדמנות',
  'op_sort__c': 'מיון הזדמנות',
  'Parent_Opportunity__c': 'הזדמנות אב',
  'Ressource_name__c': 'שם משאב',
  'not_stati__c': 'לא סטטי',
  'colection__c': 'גבייה',
  'Created_By_Flow__c': 'נוצר ע"י תהליך',
  'checks_not_allowed__c': 'צ׳קים לא מותרים',
  'no_tech_needed__c': 'לא נדרש טכנאי',
  'product_op__c': 'מוצר הזדמנות',
  'Contactid__c': 'איש קשר',
  'Stat__c': 'סטטיסטיקה',

  // WorkOrder custom fields
  'FSL__IsFillInCandidate__c': 'מועמד למילוי',
  'FSL__Prevent_Geocoding_For_Chatter_Actions__c': 'מנע גיאוקוד לפעולות',
  'FSL__VisitingHours__c': 'שעות ביקור',
  'Opportunity__c': 'הזדמנות',
  'Serialized_Product__c': 'מוצר סיריאלי',
  'Laboratory_replacement_approved_b__c': 'החלפת מעבדה מאושרת',
  'Total_Price_Product_Consumed__c': 'מחיר כולל מוצרים נצרכים',
  'Total_Quantity_Product_Consumed__c': 'כמות כוללת מוצרים נצרכים',
  'How_the_client_pay__c': 'איך הלקוח משלם',
  'Number_of_payments__c': 'מספר תשלומים',
  'Have_Discount__c': 'יש הנחה',
  'Manager_status__c': 'סטטוס מנהל',
  'Approved_By_Manger__c': 'אושר ע"י מנהל',
  'Start_Work__c': 'התחלת עבודה',
  'End_Work__c': 'סיום עבודה',
  'Create_PR__c': 'צור דרישת רכש',
  'Service_Appointment_Status__c': 'סטטוס פעילות שירות',
  'status_SA__c': 'סטטוס פ.ש.',

  // ServiceAppointment additional custom fields
  'FSL__Appointment_Grade__c': 'ציון פגישה',
  'FSL__Emergency__c': 'חירום',
  'FSL__GanttColor__c': 'צבע גנט',
  'FSL__GanttIcon__c': 'אייקון גנט',
  'FSL__Gantt_Display_Date__c': 'תאריך תצוגת גנט',
  'FSL__Last_Updated_Epoch__c': 'עדכון אחרון',
  'FSL__MDS_Calculated_length__c': 'אורך מחושב',
  'FSL__MDT_Operational_Time__c': 'זמן תפעולי',
  'FSL__Related_Service__c': 'שירות קשור',
  'FSL__Schedule_over_lower_priority_appointment__c': 'תזמון על פגישה בעדיפות נמוכה',
  'FSL__Use_Async_Logic__c': 'השתמש בלוגיקה אסינכרונית',
  'FSL__Virtual_Service_For_Chatter_Action__c': 'שירות וירטואלי',
  'Bundle_created_SA__c': 'נוצר מחבילה',
  'Error_Message__c': 'הודעת שגיאה',
  'Run_close_SA_close__c': 'הפעל סגירת פ.ש.',
  'Resource_Change_Time__c': 'זמן שינוי משאב',
  'CA1__c': 'סכום צ׳ק 1', 'CA2__c': 'סכום צ׳ק 2', 'CA3__c': 'סכום צ׳ק 3', 'CA4__c': 'סכום צ׳ק 4', 'CA5__c': 'סכום צ׳ק 5',
  'CA6__c': 'סכום צ׳ק 6', 'CA7__c': 'סכום צ׳ק 7', 'CA8__c': 'סכום צ׳ק 8', 'CA9__c': 'סכום צ׳ק 9', 'CA10__c': 'סכום צ׳ק 10',
  'CA11__c': 'סכום צ׳ק 11', 'CA12__c': 'סכום צ׳ק 12', 'CA13__c': 'סכום צ׳ק 13', 'CA14__c': 'סכום צ׳ק 14', 'CA15__c': 'סכום צ׳ק 15',
  'CN1__c': 'מספר צ׳ק 1', 'CN2__c': 'מספר צ׳ק 2', 'CN3__c': 'מספר צ׳ק 3', 'CN4__c': 'מספר צ׳ק 4', 'CN5__c': 'מספר צ׳ק 5',
  'CN6__c': 'מספר צ׳ק 6', 'CN7__c': 'מספר צ׳ק 7', 'CN8__c': 'מספר צ׳ק 8', 'CN9__c': 'מספר צ׳ק 9', 'CN10__c': 'מספר צ׳ק 10',
  'CN11__c': 'מספר צ׳ק 11', 'CN12__c': 'מספר צ׳ק 12', 'CN13__c': 'מספר צ׳ק 13', 'CN14__c': 'מספר צ׳ק 14', 'CN15__c': 'מספר צ׳ק 15',
  'FSL__Gantt_Label_Details__c': 'פרטי תווית גנט',
  'check_date__c': 'תאריך צ׳ק',
  'check_date_1__c': 'תאריך צ׳ק 1', 'check_date_2__c': 'תאריך צ׳ק 2', 'check_date_3__c': 'תאריך צ׳ק 3',
  'check_date_4__c': 'תאריך צ׳ק 4', 'check_date_5__c': 'תאריך צ׳ק 5', 'check_date_6__c': 'תאריך צ׳ק 6',
  'description_1__c': 'תיאור 1',
  'Receipt_r__c': 'קבלה',
  'client_sign_reciept__c': 'חתימת לקוח על קבלה',
  'Field1__c': 'שדה 1',
  'pr__c': 'דרישת רכש',
  'Dashboard__c': 'דשבורד',
  'paylink__c': 'קישור תשלום',
  'Apartment__c': 'דירה',

  // Case custom fields
  'Reason_2__c': 'סיבה 2',
  'Reason_1__c': 'סיבה 1',
  'Device_Type__c': 'סוג מכשיר',
  'Survey__c': 'סקר',
  'SurveyDetails__c': 'פרטי סקר',
  'ContactInformation__c': 'פרטי יצירת קשר',
  'Lead__c': 'ליד',
  'SA__c': 'פעילות שירות',
  'DateOfLastFilterReplacement__c': 'תאריך החלפת מסנן אחרון',
  'Is_Filter_Replacement_Required__c': 'נדרשת החלפת מסנן',
  'Is_Filter_Replacement__c': 'החלפת מסנן',
  'Equipment_Benefit_Reason__c': 'סיבת תועלת ציוד',
  'Approval_Manager__c': 'אישור מנהל',

  // Asset custom fields
  'Buy_Date_from_Barak__c': 'תאריך רכישה מברק',
  'End_Date_From_Barak__c': 'תאריך סיום מברק',
  'Close_date_to_collect_device__c': 'תאריך סגירה לאיסוף מכשיר',
  'Status_Date_Change__c': 'תאריך שינוי סטטוס',
  'Record_Number_Barak__c': 'מספר רשומה ברק',
  'Product_Consumed_Asset__c': 'מוצר נצרך נכס',
  'Contact_Lab__c': 'איש קשר מעבדה',
  'Lab_Status__c': 'סטטוס מעבדה',
  'Expected_end_date__c': 'תאריך סיום צפוי',
  'Reason_for_non_repair__c': 'סיבה לאי תיקון',
  'Cannot_be_fixed_in_time__c': 'לא ניתן לתקן בזמן',
  'Upcoming_Acceptance_Date__c': 'תאריך קבלה קרוב',
  'UpcomingAcceptanceDate__c': 'תאריך קבלה קרוב',
  'Upcoming Acceptance Date': 'תאריך קבלה קרוב',
  'UPCOMING_ACCEPTANCE_DATE': 'תאריך קבלה קרוב',
  'UPCOMING ACCEPTANCE DATE': 'תאריך קבלה קרוב',
  'Upcoming_Pick_Up_Date__c': 'תאריך איסוף קרוב',
  'UpcomingPickUpDate__c': 'תאריך איסוף קרוב',
  'Upcoming Pick Up Date': 'תאריך איסוף קרוב',
  'UPCOMING_PICK_UP_DATE': 'תאריך איסוף קרוב',
  'UPCOMING PICK UP DATE': 'תאריך איסוף קרוב',
  'X30_Days_Before_Replacement_Filter__c': '30 יום לפני החלפת מסנן',
  'X30DaysBeforeReplacementFilter__c': '30 יום לפני החלפת מסנן',
  'X30 Days Before Replacement Filter': '30 יום לפני החלפת מסנן',
  'X30_DAYS_BEFORE_REPLACEMENT_FILTER': '30 יום לפני החלפת מסנן',
  'X30 DAYS BEFORE REPLACEMENT FILTER': '30 יום לפני החלפת מסנן',
  'Status_Notification__c': 'התראת סטטוס',
  'StatusNotification__c': 'התראת סטטוס',
  'Status Notification': 'התראת סטטוס',
  'STATUS_NOTIFICATION': 'התראת סטטוס',
  'Owner__c': 'בעלים',
  'OWNER': 'בעלים',
  'Account_Rollup_Id__c': 'מזהה חשבון מאוחד',
  'AccountRollupId__c': 'מזהה חשבון מאוחד',
  'Account Rollup Id': 'מזהה חשבון מאוחד',
  'ACCOUNT_ROLLUP_ID': 'מזהה חשבון מאוחד',
  'ACCOUNT ROLLUP ID': 'מזהה חשבון מאוחד',
  'ProductConsumedAsset__c': 'מוצר נצרך נכס',
  'Product Consumed Asset': 'מוצר נצרך נכס',
  'PRODUCT_CONSUMED_ASSET': 'מוצר נצרך נכס',
  'PRODUCT CONSUMED ASSET': 'מוצר נצרך נכס',
  'Marketing__c': 'משווק',
  'MARKETING': 'משווק',
  'Marketing': 'משווק',

  // Hebrew field names (for labels coming from legacy CRM)
  '\u05D0\u05D6\u05D5\u05E8 \u05E9\u05D9\u05E8\u05D5\u05EA': '\u05D0\u05D6\u05D5\u05E8 \u05E9\u05D9\u05E8\u05D5\u05EA',
  '\u05E1\u05D8\u05D8\u05D5\u05E1': '\u05E1\u05D8\u05D8\u05D5\u05E1',
  '\u05DE\u05E1\u05E4\u05E8 \u05E4\u05D2\u05D9\u05E9\u05D4': '\u05DE\u05E1\u05E4\u05E8 \u05E4\u05D2\u05D9\u05E9\u05D4',
  '\u05E0\u05D5\u05E9\u05D0': '\u05E0\u05D5\u05E9\u05D0',
  '\u05EA\u05D9\u05D0\u05D5\u05E8': '\u05EA\u05D9\u05D0\u05D5\u05E8',
  '\u05D7\u05E9\u05D1\u05D5\u05DF': '\u05D7\u05E9\u05D1\u05D5\u05DF',
  '\u05D0\u05D9\u05E9 \u05E7\u05E9\u05E8': '\u05D0\u05D9\u05E9 \u05E7\u05E9\u05E8',
  '\u05E8\u05E9\u05D5\u05DE\u05D4 \u05E7\u05E9\u05D5\u05E8\u05D4': '\u05E8\u05E9\u05D5\u05DE\u05D4 \u05E7\u05E9\u05D5\u05E8\u05D4',
  '\u05D6\u05DE\u05DF \u05D4\u05EA\u05D7\u05DC\u05D4 \u05DE\u05EA\u05D5\u05D6\u05DE\u05DF': '\u05D6\u05DE\u05DF \u05D4\u05EA\u05D7\u05DC\u05D4 \u05DE\u05EA\u05D5\u05D6\u05DE\u05DF',

  // Account - missing fields
  'Agent_ID__c': 'מזהה סוכן',
  'Agent_Name__c': 'שם סוכן',
  'Contact_Name__c': 'שם איש קשר',
  'Deal_cancelled__c': 'עסקה בוטלה',
  'Neighborhood__c': 'שכונה',
  'PersonOtherPhone': 'טלפון נוסף',
  'Phoneforbot__c': 'טלפון לבוט',

  // Product2 - missing fields
  'Family': 'משפחת מוצרים',
  'Campaign__c': 'קמפיין',
  'Current_Stock__c': 'מלאי נוכחי',
  'Image_Product__c': 'תמונת מוצר',
  'Image_URL__c': 'קישור תמונה',
  'IsSerialized': 'מנוהל סיריאלית',
  'Last_Movement_Date__c': 'תאריך תנועה אחרונה',
  'Min_Allowed_UnitPrice__c': 'מחיר מינימלי ליחידה',
  'Minimum_Stock__c': 'מלאי מינימלי',
  'Product_Color__c': 'צבע מוצר',
  'Reorder_Quantity__c': 'כמות להזמנה חוזרת',
  'TransferRecordMode': 'מצב העברת רשומות',

  // OpportunityLineItem - missing fields
  'Product_Image__c': 'תמונת מוצר',

  // ProductRequired - missing fields
  'Quantity_Text__c': 'כמות (טקסט)',
  'product_fa__c': 'משפחת מוצר',
  'CreatedByFlow__c': 'נוצר ע"י תהליך',
  'ParentRecordType': 'סוג רשומה אב',

  // Opportunity - missing fields
  'SA_Status__c': 'סטטוס פעילות שירות',
  'Reminder_Send_Email__c': 'שליחת תזכורת במייל',
  'ressource_n__c': 'מספר משאב',
  'start_work__c': 'התחלת עבודה',

  // WorkOrder - missing fields
  'FSL__Scheduling_Priority__c': 'עדיפות תזמון',
  'Opportunity_Amount__c': 'סכום הזדמנות',

  // Asset - missing fields
  'StatusReason': 'סיבת סטטוס',
  'ProductDescription': 'תיאור מוצר',
  'ProductFamily': 'משפחת מוצרים',
  'ManufactureDate': 'תאריך ייצור',
  'Availability': 'זמינות',
  'Reliability': 'אמינות',
  'MeanTimeBetweenFailures': 'זמן ממוצע בין תקלות',
  'MeanTimeToRepair': 'זמן ממוצע לתיקון',

  // Case - missing fields
  'ProductId': 'מוצר',

  // Payment__c - all fields
  'Account__c': 'חשבון',
  'Amount__c': 'סכום',
  'Payment_Type__c': 'סוג תשלום',
  'Payment_Status__c': 'סטטוס תשלום',
  'Description__c': 'תיאור',
  'Postpone_Reason__c': 'סיבה לדחיית משימה',
  'Link_To_Document__c': 'קישור למסמך',
  'Receipt_Number__c': 'מספר קבלה',
  'Receipt_Status__c': 'סטטוס קבלה',
  'Payment_Terms__c': 'תנאי תשלום',
  'Bank_Name__c': 'שם בנק',
  'Bank_Branch__c': 'סניף בנק',
  'Bank_Account_Number__c': 'מספר חשבון בנק',
  'Bank_Transfer_Number__c': 'מספר העברה בנקאית',
  // 2026-07-16: standing-order approval number. Distinct from Auth_Num__c,
  // which is the iCredit credit-card auth. Single source of truth — the value
  // is no longer written into Description__c.
  'Standing_Order_Approval__c': 'מספר אישור הוראת קבע',
  'Standing_Order_Phone__c': 'נשלח לאישור לטלפון',
  'Standing_Order_First_Debit__c': 'תאריך חיוב ראשון',
  'Card_Last_4_Digits__c': '4 ספרות אחרונות',
  'CreditCard_Name__c': 'שם בעל כרטיס',
  'CreditCard_Transaction_Number__c': 'מספר עסקת אשראי',
  'Check_Number__c': 'מספר צ׳ק',
  'Customer_Id__c': 'ת.ז. לקוח',
  'Customer_Transaction_Id__c': 'מזהה עסקת לקוח',
  'Document_Type__c': 'סוג מסמך',
  'Accounting_Month__c': 'חודש הנהלת חשבונות',
  'Accounting_Year__c': 'שנת הנהלת חשבונות',
  'Accounting_Line_Id__c': 'מזהה שורה חשבונאית',
  'Accounting_Error_Message__c': 'הודעת שגיאה חשבונאית',
  'PaymentMessage__c': 'הודעת תשלום',
  'PaymentStatus__c': 'סטטוס תשלום',
  'Payment_Message__c': 'הודעת תשלום',
  'Payment_Status_Log__c': 'יומן סטטוס תשלום',
  'Payment_Request_Id__c': 'מזהה בקשת תשלום',
  'Payment_Cancellation__c': 'ביטול תשלום',
  'Original_Payment__c': 'תשלום מקורי',
  'Status_Color__c': 'צבע סטטוס',
  'Token__c': 'טוקן',
  'Private_Sale_Token__c': 'טוקן מכירה פרטי',
  'Public_Sale_Token__c': 'טוקן מכירה ציבורי',
  'Sale_Id__c': 'מזהה מכירה',
  'User_op__c': 'משתמש הזדמנות',
  'Invoice_Request_Status__c': 'סטטוס בקשת חשבונית',
  'Invoice_Request_Message__c': 'הודעת בקשת חשבונית',
  'checksdetails__c': 'פרטי צ׳קים',
  'description_rivka__c': 'תיאור ריווחית',
  'part_of_payment__c': 'חלק מתשלום',
  'Number_Of_Payments__c': 'מספר תשלומים',

  // === Hebrew translations added 2026-05-07 (97 fields, owner-approved) ===
  // Account
  'ChannelProgramLevelName': 'רמת תוכנית ערוץ',
  'ChannelProgramName': 'שם תוכנית ערוץ',
  'IsPartner': 'שותף',
  'Jigsaw': 'מזהה Jigsaw',
  'OperatingHoursId': 'שעות פעילות',
  'Ownership': 'סוג בעלות',
  'PersonAssistantName': 'שם המזכיר/ה',
  'PersonAssistantPhone': 'טלפון המזכיר/ה',
  'PersonDepartment': 'מחלקה',
  'PersonDoNotCall': 'אין להתקשר',
  'PersonGenderIdentity': 'זהות מגדרית',
  'PersonHasOptedOutOfFax': 'ביטול קבלת פקס',
  'PersonHomePhone': 'טלפון בית',
  'PersonLastCURequestDate': 'תאריך בקשת עדכון אחרון',
  'PersonLastCUUpdateDate': 'תאריך עדכון אחרון',
  'PersonPronouns': 'כינויי גוף',
  'Sic': 'קוד SIC',
  'SicDesc': 'תיאור SIC',
  'SourceSystemIdentifier': 'מזהה מערכת מקור',
  'Test_Field__c': 'שדה בדיקה',
  'TickerSymbol': 'סמל מניה',
  'Tier': 'רובד',
  'Transition_to_a_Agent__c': 'העברה לנציג',
  'Type_of_transfer_to_customer__c': 'סוג העברה ללקוח',
  'WhatsApp_Service_Confirmation__c': 'אישור שירות בוואטסאפ',
  // Opportunity
  'ContractId': 'חוזה',
  'IqScore': 'ציון IQ',
  'IsPrivate': 'פרטי',
  'PartnerAccountId': 'חשבון שותף',
  'SyncedQuoteId': 'הצעת מחיר מסונכרנת',
  // Asset
  'AssetLevel': 'רמת נכס',
  'AssetProvidedById': 'סופק על ידי',
  'AssetServicedById': 'טופל על ידי',
  'AverageUptimePerDay': 'זמן פעילות ממוצע ליום',
  'ConsequenceOfFailure': 'השלכות כשל',
  'DigitalAssetStatus': 'סטטוס נכס דיגיטלי',
  'ExternalIdentifier': 'מזהה חיצוני',
  'SumDowntime': 'סך זמן השבתה',
  'SumUnplannedDowntime': 'סך זמן השבתה לא מתוכנן',
  'Upcoming_acceptance_date__c': 'תאריך התקנה צפוי',
  'Upcoming_pick_up_date__c': 'תאריך איסוף צפוי',
  'UptimeRecordEnd': 'סיום רישום זמן פעילות',
  'UptimeRecordStart': 'התחלת רישום זמן פעילות',
  'Uuid': 'UUID',
  'X30_days_before_replacement_filter__c': 'חודש לפני החלפת פילטר',
  // Case
  'AssetWarrantyId': 'אחריות נכס',
  'BusinessHoursId': 'שעות עסק',
  'ContactEmail': 'דוא"ל איש קשר',
  'ContactFax': 'פקס איש קשר',
  'ContactMobile': 'נייד איש קשר',
  'ContactPhone': 'טלפון איש קשר',
  'EntitlementId': 'זכאות',
  'IsClosedOnCreate': 'נסגר ביצירה',
  'IsStopped': 'מושהה',
  'Language': 'שפה',
  'MilestoneStatus': 'סטטוס אבן דרך',
  'MilestoneStatusIcon': 'סמל סטטוס אבן דרך',
  'SlaExitDate': 'תאריך יציאה מ-SLA',
  'SlaStartDate': 'תאריך תחילת SLA',
  'SourceId': 'מקור',
  'StopStartDate': 'תאריך תחילת השהיה',
  // WorkOrder
  // (dedup) 'AssetWarrantyId' translation already added above
  // (dedup) 'BusinessHoursId' translation already added above
  // (dedup) 'EntitlementId' translation already added above
  'FSL_Is_Linked_To_Maintenance_Plan__c': 'מקושר לתוכנית תחזוקה',
  'FSL_Is_Linked_To_Service_Contract__c': 'מקושר לחוזה שירות',
  // (dedup) 'IsStopped' translation already added above
  // (dedup) 'MilestoneStatus' translation already added above
  // (dedup) 'MilestoneStatusIcon' translation already added above
  'PostWorkSummary': 'סיכום לאחר עבודה',
  'PreWorkBriefPromptTemplate': 'תבנית תדריך לפני עבודה',
  'ProductServiceCampaignId': 'קמפיין שירות מוצר',
  'ProductServiceCampaignItemId': 'פריט קמפיין שירות מוצר',
  'ReturnOrderId': 'הזמנת החזרה',
  'ReturnOrderLineItemId': 'פריט הזמנת החזרה',
  'ServiceReportLanguage': 'שפת דוח שירות',
  'ServiceReportTemplateId': 'תבנית דוח שירות',
  // (dedup) 'SlaExitDate' translation already added above
  // (dedup) 'SlaStartDate' translation already added above
  'StatusCategory': 'קטגוריית סטטוס',
  // (dedup) 'StopStartDate' translation already added above
  // ServiceAppointment
  'ApptBookingInfoUrl': 'קישור פרטי תיאום',
  'BundlePolicyId': 'מדיניות חבילה',
  'FSL_Compliance__c': 'ציות',
  'FSL_FTFR_Count__c': 'ספירת FTFR',
  'FSL__Duration_In_Minutes__c': 'משך מתוכנן (דקות)',
  'FSL__InternalSLRGeolocation__c': 'מיקום גיאוגרפי (קו אורך ורוחב)',
  'IsBundle': 'חבילה',
  'IsBundleMember': 'חבר חבילה',
  'IsManuallyBundled': 'איגוד ידני',
  'IsOffsiteAppointment': 'פעילות מחוץ לאתר',
  'ParentRecordStatusCategory': 'קטגוריית סטטוס רשומת אב',
  'RelatedBundleId': 'חבילה משויכת',
  // (dedup) 'StatusCategory' translation already added above
  'TimeZone': 'אזור זמן',
  'Transaction': 'עסקה',
  'TravelTimeBuffer': 'מרווח זמן נסיעה',
};

/**
 * Look up a Hebrew label for a field name, with multiple fallback strategies.
 * @param {string} fieldName - The field API name to look up
 * @returns {string|null} The Hebrew label, or null if not found
 */
export const getHebrewFieldLabel = (fieldName) => {
  if (!fieldName) return null;

  // Direct match
  if (HEBREW_FIELD_LABELS[fieldName]) return HEBREW_FIELD_LABELS[fieldName];

  // Try uppercase
  if (HEBREW_FIELD_LABELS[fieldName.toUpperCase()]) return HEBREW_FIELD_LABELS[fieldName.toUpperCase()];

  // Try with spaces replaced by underscores and vice versa
  const withUnderscores = fieldName.replace(/ /g, '_');
  if (HEBREW_FIELD_LABELS[withUnderscores]) return HEBREW_FIELD_LABELS[withUnderscores];

  const withSpaces = fieldName.replace(/_/g, ' ');
  if (HEBREW_FIELD_LABELS[withSpaces]) return HEBREW_FIELD_LABELS[withSpaces];
  if (HEBREW_FIELD_LABELS[withSpaces.toUpperCase()]) return HEBREW_FIELD_LABELS[withSpaces.toUpperCase()];

  // Try without object prefix (e.g., Account.Name -> Name)
  const simpleName = fieldName.split('.').pop();
  if (HEBREW_FIELD_LABELS[simpleName]) return HEBREW_FIELD_LABELS[simpleName];
  if (HEBREW_FIELD_LABELS[simpleName.toUpperCase()]) return HEBREW_FIELD_LABELS[simpleName.toUpperCase()];

  // Try CamelCase conversion
  const camelCase = fieldName.toLowerCase().replace(/(?:^\w|[A-Z]|\b\w|\s+\w)/g, (match, index) =>
    index === 0 ? match.toLowerCase() : match.toUpperCase()
  ).replace(/\s+/g, '');
  if (HEBREW_FIELD_LABELS[camelCase]) return HEBREW_FIELD_LABELS[camelCase];

  // Try PascalCase
  const pascalCase = fieldName.replace(/\w+/g, w => w[0].toUpperCase() + w.slice(1).toLowerCase()).replace(/\s+/g, '');
  if (HEBREW_FIELD_LABELS[pascalCase]) return HEBREW_FIELD_LABELS[pascalCase];

  // Try with __c suffix
  if (HEBREW_FIELD_LABELS[`${simpleName}__c`]) return HEBREW_FIELD_LABELS[`${simpleName}__c`];
  if (HEBREW_FIELD_LABELS[`${pascalCase}__c`]) return HEBREW_FIELD_LABELS[`${pascalCase}__c`];

  return null;
};

/**
 * Look up a Hebrew label for an object API name.
 * @param {string} apiName - The object API name to look up
 * @returns {string|null} The Hebrew label, or null if not found
 */
export const getHebrewObjectLabel = (apiName) => {
  return HEBREW_OBJECT_LABELS[apiName] || null;
};

// Picklist value translations, keyed by 'Object.Field' for precise per-field lookup,
// or by field API name alone (when value translation is shared across objects).
// API value (the dict key) is unchanged in DB and code; only display text is translated.
export const HEBREW_PICKLIST_VALUES = {
  // 2026-05-21: ServiceContract.ApprovalStatus values follow EndDate
  // (nightly cron at 00:30 IDT flips them). Owner wanted plain
  // "פעיל" / "לא פעיל" in the UI rather than the raw SF strings.
  'ServiceContract.ApprovalStatus': {
    'Activated': 'פעיל',
    'Expired': 'לא פעיל',
    'Draft': 'טיוטה',
    'Cancelled': 'בוטל',
    'Approved': 'אושר',
    'Deactivated': 'מושבת',
  },
  // ===== Phase 3 (2026-05-07, owner-approved) =====
  'Opportunity.Loss_Reason__c': {
    'Lost to Competitor': 'אבד למתחרה',
    'No Budget / Lost Funding': 'ללא תקציב / איבוד מימון',
    'No Decision / Non-Responsive': 'ללא החלטה / לא מגיב',
    'Price': 'מחיר',
    'Other': 'אחר',
  },
  'ServiceAppointment.FSL__InJeopardyReason__c': {
    'Delayed Start': 'התחלה מאוחרת',
    'Delayed Finish': 'סיום מאוחר',
    'No Response': 'אין מענה',
    'Due Date Approaching': 'מועד יעד מתקרב',
  },
  'ServiceAppointment.FSL__Schedule_Mode__c': {
    'Manual': 'ידני',
    'Automatic': 'אוטומטי',
    'Optimization': 'אופטימיזציה',
    'None': 'ללא',
    'Drag and Drop': 'גרירה ושחרור',
    'Schedule': 'תזמון',
    'Global Optimization': 'אופטימיזציה גלובלית',
    'In Day Optimization': 'אופטימיזציה ביום',
    'Resource Optimization': 'אופטימיזציית משאבים',
  },
  'ServiceAppointment.FSL__Time_Dependency__c': {
    'Same Start': 'התחלה משותפת',
    'Start After Finish': 'התחלה אחרי סיום',
    'Finish Before Start': 'סיום לפני התחלה',
  },
  'ServiceAppointment.Reason_Cannot_Completed__c': {
    'None': 'ללא',
    'Missing Part': 'חסר חלק',
    'Send to Lab': 'שליחה למעבדה',
  },
  'ServiceAppointment.Status': {
    'None': 'ללא',
    'Scheduled': 'פגישה מתוזמנת',
    'Dispatched': 'תואמה התקנה',
    'In Progress': 'בתהליך',
    'Completed': 'הושלם',
    'Cannot Complete': 'לא ניתן להשלים',
    'Canceled': 'פגישה בוטלה',
  },
  'WorkOrder.Status': {
    'New': 'חדש',
    'Open': 'פתוח',
    'In Progress': 'בטיפול',
    'On Hold': 'בהמתנה',
    'Completed': 'הושלם',
    'Closed': 'סגור',
    'Cannot Complete': 'לא ניתן להשלים',
    'Canceled': 'בוטל',
    'Cancelled': 'בוטל',
    'Scheduled': 'מתוזמן',
  },
  'Task.Status': {
    'Not Started': 'לא התחיל',
    'In Progress': 'בתהליך',
    'Completed': 'הושלם',
    'Waiting on someone else': 'ממתין',
    'Deferred': 'נדחה',
  },
  'Task.Priority': {
    'High': 'גבוהה',
    'Normal': 'רגילה',
    'Low': 'נמוכה',
  },
  'Payment__c.Payment_Type__c': {
    'Credit Card': 'כרטיס אשראי',
    'credit_card': 'כרטיס אשראי',
    'Cash': 'מזומן',
    'cash': 'מזומן',
    'Check': 'שיק',
    'check': 'שיק',
    'Bank Transfer': 'העברה בנקאית',
    'bank_transfer': 'העברה בנקאית',
    'Bit': 'ביט',
    'bit': 'ביט',
    'Standing Order': 'הוראת קבע',
    'standing_order': 'הוראת קבע',
  },
  'Payment__c.Payment_Status__c': {
    'SUCCESS': 'הצלחה',
    'Success': 'הצלחה',
    'PENDING': 'ממתין',
    'In process': 'ממתין לתשלום',
    'FAILED': 'נכשל',
    'Error': 'שגיאה',
    'Verify': 'אימות נדרש',
    'Need To Be Paid': 'ממתין לתשלום',
    'Paid': 'שולם',
    'Create Receipt': 'יצירת קבלה',
    'Create Invoice': 'יצירת חשבונית',
    'Returned': 'שיק חוזר',
    'תשלום בוטל בחברת האשראי': 'תשלום בוטל',
    'תשלום בוטל': 'תשלום בוטל',
    'תשלום בוטל חלקית': 'תשלום בוטל חלקית',
  },
  'WorkOrder.How_the_client_pay__c': {
    'Credit Card': 'כרטיס אשראי',
    'Check': 'שיק',
    'Cash': 'מזומן',
    'Other': 'אחר',
  },
  'WorkOrder.Manager_status__c': {
    'Approved': 'מאושר',
    'Refusal': 'סירוב',
  },
};

/**
 * Look up a Hebrew label for a picklist value.
 * @param {string} objectName - Object API name (e.g., 'ServiceAppointment')
 * @param {string} fieldName - Field API name (e.g., 'Status')
 * @param {string} value - The API value of the picklist (e.g., 'Scheduled')
 * @returns {string} Hebrew label if found, otherwise the value itself
 */
export const getHebrewPicklistValue = (objectName, fieldName, value) => {
  if (value == null || value === '') return value;
  // Try Object.Field for precise lookup
  if (objectName && fieldName) {
    const objField = HEBREW_PICKLIST_VALUES[`${objectName}.${fieldName}`];
    if (objField && objField[value]) return objField[value];
  }
  // Try Field-only key
  if (fieldName) {
    const fieldOnly = HEBREW_PICKLIST_VALUES[fieldName];
    if (fieldOnly && fieldOnly[value]) return fieldOnly[value];
    // When object is unknown, scan for any '*.fieldName' key
    const suffix = '.' + fieldName;
    for (const key in HEBREW_PICKLIST_VALUES) {
      if (key.endsWith(suffix) && HEBREW_PICKLIST_VALUES[key][value]) {
        return HEBREW_PICKLIST_VALUES[key][value];
      }
    }
  }
  return value;
};
